import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';

@Injectable({ providedIn: 'root' })
export class OutgoingWebhookService extends AutomationDisplayService {
  constructor(protected readonly translateService: TranslateService) {
    super();
  }

  getActivityColumn(_namespace: string, activity: ActivityInterface): ActivityTableEntry {
    const data = activity.workflowStep?.data ? JSON.parse(activity.workflowStep.data) : {};
    const allOutputData = activity?.outputData ? JSON.parse(activity.outputData) : {};
    const stepOutput = allOutputData?.WorkflowStep[activity.workflowStep?.id]
      ? allOutputData.WorkflowStep[activity.workflowStep?.id]
      : {};
    // Remove the other outputs from this step as it doesn't really make sense to the user when they are trying
    // to understand what's happening with their webhooks.
    const curlCommand = stepOutput.curl_command;
    delete stepOutput.endpoint_url;
    delete stepOutput.curl_command;

    // The endpoint can accept user input, including HTML, so we need to make it display nicely
    // Angular will handle removing scripts in the template to meet security standards
    for (const stepOutputKey in stepOutput) {
      stepOutput[stepOutputKey] = this.escapeHTML(stepOutput[stepOutputKey]);
    }

    return this.tableEntry(
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.OUTGOING_WEBHOOK.ACTIVITY.TITLE'),
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.OUTGOING_WEBHOOK.ACTIVITY.SUBTITLE_WITH_RESPONSE', {
        endpointUrl: data.endpoint_url,
        responseBody: JSON.stringify(stepOutput, null, 2),
        curlCommand: curlCommand,
      }),
    );
  }

  escapeHTML(html: string): string {
    const escape = document.createElement('textarea');
    escape.textContent = html;
    return escape.innerHTML;
  }

  getAutomationNodeData(
    _namespace: string,
    step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    const data = step?.data ? JSON.parse(step.data) : {};
    if (data.endpoint_url) {
      return this.nodeDisplayData(
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.OUTGOING_WEBHOOK.ACTION', {
          endpointUrl: data.endpoint_url,
        }),
        this.noValidationErrorsDetected(),
      );
    } else {
      return this.nodeDisplayData(
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.TEMPLATE'),
        this.validationErrorsDetected(step, '', true),
      );
    }
  }

  getTemplateNodeData(
    _namespace: string,
    step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    const data = step?.data ? JSON.parse(step.data) : {};
    if (data.endpoint_url) {
      return this.nodeDisplayData(
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.OUTGOING_WEBHOOK.ACTION', {
          endpointUrl: data.endpoint_url,
        }),
        this.noValidationErrorsDetected(),
      );
    } else {
      return this.nodeDisplayData(
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.TRIGGER_WEBHOOK.TEMPLATE'),
        this.noValidationErrorsDetected(),
      );
    }
  }
}
